<template>
  <v-container fluid>
    <div v-if="authState !== 'signedin'">You are signed out.</div>
    <amplify-authenticator>
      <div v-if="authState === 'signedin' && user">
        <v-card>
          <v-row no-gutters>
            <v-card-title class="text-h5"> Companies </v-card-title>
            <v-card-actions>
              <v-btn
                depressed
                min-width="0"
                color="green"
                :dark="!loadingLoanTypes"
                :disabled="loadingLoanTypes"
                :loading="loadingLoanTypes"
                @click="addCompany()"
              >
                <v-icon> mdi-plus </v-icon>
              </v-btn></v-card-actions
            >
          </v-row>
          <v-data-table
            :headers="headers"
            :items="companies"
            item-key="id"
            :loading="loading"
            loading-text="Loading Companies..."
            :search="search"
            class="AdminCompanies"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog
                  persistent
                  v-model="viewCompanyDialog"
                  max-width="90%"
                >
                  <v-card>
                    <ViewSingleCompany
                      :company="viewingItem"
                      :loanTypes="loanTypes"
                      v-if="viewingItem"
                    />
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        width="4vh"
                        color="green"
                        dark
                        @click="viewCompanyClose"
                      >
                        Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog persistent v-model="addCompanyDialog" max-width="90%">
                  <v-card>
                    <AddSingleCompany
                      :loanTypes="loanTypes"
                      @createdCompany="addCompanyClose"
                      v-if="addCompanyDialog"
                    />
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        width="4vh"
                        color="green"
                        dark
                        @click="addCompanyClose"
                      >
                        Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small class="mr-2" @click="viewItem(item)">
                mdi-eye
              </v-icon>
            </template>
          </v-data-table>
          <v-card-actions>
            <span class="red--text caption">{{ error }}</span>
          </v-card-actions>
        </v-card>
      </div>
    </amplify-authenticator>
  </v-container>
</template>

<script>
import { layout } from "@/mixins";
import { onAuthUIStateChange } from "@aws-amplify/ui-components";
import { DataStore } from "@aws-amplify/datastore";
import { Company, LoanType } from "@/models";
import ViewSingleCompany from "@/components/admin/ViewSingleCompany";
import AddSingleCompany from "@/components/admin/AddSingleCompany";

export default {
  mixins: [layout],
  name: "AdminCompanies",
  components: {
    ViewSingleCompany,
    AddSingleCompany,
  },
  data: () => ({
    theme: "admin",
    loading: true,
    loadingLoanTypes: true,
    error: null,
    companies: [],
    loanTypes: null,
    user: undefined,
    authState: undefined,
    unsubscribeAuth: undefined,
    search: "",

    viewCompanyDialog: false,
    addCompanyDialog: false,
    viewingItem: {},

    editDialog: false,
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    headers: [
      {
        text: "Company",
        value: "name",
        class: "grey lighten-2",
      },
      {
        text: "Company Code",
        value: "pastelCode",
      },
      {
        text: "Email",
        value: "companyEmail",
        class: "grey lighten-2",
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
      },
    ],
  }),

  mounted() {
    this.queryCompanies();
    this.unsubscribeAuth = onAuthUIStateChange((authState, authData) => {
      this.authState = authState;
      this.user = authData;
      this.queryCompanies();
    });
  },
  methods: {
    async queryCompanies() {
      try {
        this.subscription = DataStore.observeQuery(Company).subscribe(
          async (snapshot) => {
            const { items, isSynced } = snapshot;
            if (isSynced) {
              this.companies = items;
              this.loading = false;
              this.subscription.unsubscribe();
              this.queryLoanTypes();
            }
          }
        );
      } catch (err) {
        console.log(err);
      }
    },

    async queryLoanTypes() {
      try {
        this.subscription = DataStore.observeQuery(LoanType).subscribe(
          async (snapshot) => {
            const { items, isSynced } = snapshot;
            if (isSynced) {
              this.loanTypes = items;
              this.loadingLoanTypes = false;
              // this.subscription.unsubscribe();
            }
          }
        );
      } catch (err) {
        console.log(err);
      }
    },
    addCompany() {
      this.addCompanyDialog = true;
    },
    viewItem(item) {
      this.viewingItem = Object.assign({}, item);
      this.viewCompanyDialog = true;
    },

    editItem(item) {
      this.editedIndex = this.applications.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editDialog = true;
    },
    editClose() {
      this.editDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    addCompanyClose() {
      this.addCompanyDialog = false;
    },
    viewCompanyClose() {
      this.viewingItem = null;
      this.viewCompanyDialog = false;
    },
  },
  watch: {
    editDialog(val) {
      val || this.editClose();
    },
    editDialogDelete(val) {
      val || this.closeDelete();
    },
  },
  beforeDestroy() {
    // this.unsubscribeAuth();
    this.subscription.unsubscribe();
  },
};
</script>